import React from "react";
import { useTranslation } from "react-i18next";
import { trackPropertyClick } from "../utils/analytics";

export const PropertyCard = ({ property }) => {
  const { t } = useTranslation();

  const handleClick = () => {
    trackPropertyClick(property.title, property.location, property.price);
  };

  return (
    <a 
      href={property.link} 
      target="_blank" 
      rel="noopener noreferrer"
      className="property-card-link"
      onClick={handleClick}
    >
      <div className="property-card">
        <div className="property-image">
          <img src={property.image} alt={property.title} />
          {property.price && (
            <div className="property-price">{property.price}</div>
          )}
        </div>
        <div className="property-content">
          <h4 className="property-title">{property.title}</h4>
          <p className="property-location">
            <i className="fa fa-map-marker"></i> {property.location}
          </p>
          <div className="property-details">
            <div className="property-detail-item">
              <i className="fa fa-arrows-alt"></i>
              <span>{property.area}</span>
            </div>
            <div className="property-detail-item">
              <i className="fa fa-bed"></i>
              <span>{property.bedrooms}</span>
            </div>
            {property.bathrooms && (
              <div className="property-detail-item">
                <i className="fa fa-bath"></i>
                <span>{property.bathrooms}</span>
              </div>
            )}
          </div>
          {property.developer && (
            <p className="property-developer">
              <strong>{t('propertyCard.developer')}:</strong> {property.developer}
            </p>
          )}
          {property.completion && (
            <p className="property-completion">
              <strong>{t('propertyCard.completion')}:</strong> {property.completion}
            </p>
          )}
        </div>
      </div>
    </a>
  );
};

